// extracted by mini-css-extract-plugin
export default {"tab_container":"tab_container__oPpUd","tab_normal":"tab_normal__oqeZN","tab_active":"tab_active__uUs2M"};